<template>
  <div>
    <p class="warning--text">Gmailの送信画面へ移ります</p>
    <VBtn @click="send" color="primary">待機をお願いするメールを送信する</VBtn>
  </div>
</template>

<script>
import { HfMemberGetStandbyRequestMailQueryService, HfMemberGetGmailUrlCommandService } from 'hfapi/jtj'

export default {
  props: {
    application: {
      type: Object
    }
  },
  explanation: "待機をお願いするメールを送る．",
  methods: {
    async send(){
      const mailParams = new HfMemberGetStandbyRequestMailQueryService.Params
      mailParams.application_id = this.application.id
      const resp = await HfMemberGetStandbyRequestMailQueryService.execute(mailParams)
      const gmailUrlParams = new HfMemberGetGmailUrlCommandService.Params
      gmailUrlParams.mail = resp.data
      const gmailUrlResp = await HfMemberGetGmailUrlCommandService.execute(gmailUrlParams)
      window.open(gmailUrlResp.data, '_blank')
    }
  }
}
</script>

<style>

</style>